import React from 'react';
import { Root, Toggle } from './styles';
import { cx } from '@linaria/core';
export function Switch({ isEnabled = false, onClick, id, label, isDisabled = false }) {
    /** JSX */
    return (React.createElement("div", { className: cx(Root.base, isDisabled && Root.isDisabled), onClick: onClick },
        React.createElement("div", { className: cx(Toggle.base, isEnabled && Toggle.isEnabled) }, isEnabled ? 'An' : 'Aus'),
        React.createElement("input", { type: "checkbox", defaultChecked: isEnabled, id: id, "aria-label": label, role: "switch", disabled: isDisabled, "aria-checked": isEnabled })));
}
export default React.memo(Switch);
